$(function () {
  if (!customElements.get('content-popup')) {
    customElements.define(
      'content-popup',
      class ContentPopup extends HTMLElement {
        constructor() {
          super();
          this.popup = null;
          this.backdrop = null;
          this.openButtons = null;
          this.closeButtons = null;
          this.scrollArea = null;
          this.popupHeader = null;
          this.popupMainImg = null;
          this.headerHeight = 0;
          this.currentWidth = 100;
          this.lastScrollTop = 0;
          this.scrollThreshold = 10;
        }

        connectedCallback() {
          this.initializeElements();
          this.bindEvents();
        }

        disconnectedCallback() {
          this.unbindEvents();
        }

        initializeElements() {
          this.popup = this.querySelector('.popup');
          this.backdrop = this.querySelector('#popupBackdrop');
          this.openButtons = this.querySelectorAll('.openPopup');
          this.closeButtons = this.querySelectorAll('.closePopup');
          this.scrollArea = this.querySelector('.scrollArea');
        }

        bindEvents() {
          this.openButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
              const buttonId = button.getAttribute('data-id');
              this.openPopup(event, buttonId);
            });
          });

          this.closeButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
              const buttonId = button.getAttribute('data-id');
              this.closePopup(event, buttonId);
            });
          });

          if (this.backdrop) {
            this.backdrop.addEventListener('click', this.closePopup.bind(this));
          }
        }

        unbindEvents() {
          this.openButtons.forEach((button) => {
            button.removeEventListener('click', this.openPopup);
          });
          this.closeButtons.forEach((button) => {
            button.removeEventListener('click', this.closePopup);
          });

          if (this.backdrop) {
            this.backdrop.removeEventListener('click', this.closePopup);
          }

          if (this.scrollArea) {
            this.scrollArea.removeEventListener('scroll', this.handleScroll.bind(this));
          }
        }

        handleScroll() {
          const imageArea = this.popupMainImg[0];
          const scrollableArea = this.scrollArea;
          const scrollTop = scrollableArea.scrollTop;

          if (scrollTop === 0) {
            imageArea.style.transition = 'width 0.3s ease-out';
            imageArea.style.width = '100%';
            this.currentWidth = 100;
            return;
          }

          const scrollChange = scrollTop - this.lastScrollTop;
          this.lastScrollTop = scrollTop;

          let newWidth = this.currentWidth - scrollChange / 10;
          newWidth = Math.max(newWidth, 60);
          newWidth = Math.round(newWidth);

          if (newWidth !== this.currentWidth) {
            this.currentWidth = newWidth;
            imageArea.style.transition = 'width 0.1s ease-out';
            requestAnimationFrame(() => {
              imageArea.style.width = `${newWidth}%`;
            });
          }
        }

        openPopup(event, buttonId) {
          const targetPopup = this.querySelector(`.popup[data-id="${buttonId}"]`);
          if (targetPopup) {
            this.popup = targetPopup;

            const popupHeight = this.popup.offsetHeight;
            const windowHeight = window.innerHeight;

            const startY = windowHeight;
            const endY = -(popupHeight / 2);

            this.popup.style.display = 'block';
            this.popup.style.transform = `translate(-50%,-50%)`; // 初始位置
            this.backdrop.style.display = 'block';
            document.documentElement.style.overflow = 'hidden';

            this.popupHeader = targetPopup.querySelectorAll('.popup-header');
            this.popupMainImg = targetPopup.querySelectorAll('.popup-main-img');
            this.scrollArea = targetPopup.querySelector('.scrollArea');

            this.calculateScrollAreaHeight();

            // 替代动画部分
            this.popup.style.transition = 'transform 0.3s ease-out';
            setTimeout(() => {
              this.popup.style.transform = `translate(-50%,-50%)`; // 目标位置
            }, 0);

            this.scrollArea.addEventListener('scroll', this.handleScroll.bind(this));
          }
        }

        closePopup(event, buttonId) {
          document.documentElement.style.overflow = 'unset';
          document.body.style.overflow = 'unset';

          const targetPopup = this.querySelector(`.popup[data-id="${buttonId}"]`);
          if (targetPopup) {
            // 替代动画部分
            targetPopup.style.transition = 'transform 0.3s ease-in';
            targetPopup.style.transform = 'translate(-50%,100%)'; // 离开屏幕

            // 等动画完成后隐藏
            setTimeout(() => {
              targetPopup.style.display = 'none';
            }, 300);

            this.backdrop.style.display = 'none';
          }

          if (this.scrollArea) {
            this.scrollArea.removeEventListener('scroll', this.handleScroll.bind(this));
          }
        }

        calculateScrollAreaHeight() {
          if (this.popupHeader.length > 0) {
            this.headerHeight = this.popupHeader[0].offsetHeight;
          }

          if (this.scrollArea && this.popup) {
            const contentHeight = this.popup.offsetHeight - this.headerHeight - 80;
            this.scrollArea.style.height = `${contentHeight}px`;
            this.scrollArea.style.padding = '0 0 100px 0';
          }
        }
      }
    );
  }
});
